import { Button, Col, Row } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import CustomBreadcrumb from '../../../components/customBreadcrumb/CustomBreadcrumb';
import TextInput from '../../../components/textInput/TextInput';
import Title from '../../../components/title/Title';

interface IFormInputs {
  CCTID: string;
  faultRefId: string;
  rfoRefId: string;
}

const RfoRequest = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInputs>();

  const onSubmit: SubmitHandler<IFormInputs> = (data) => {
    console.log(data);
  };

  return (
    <div className='page-container'>
      <CustomBreadcrumb
        items={[
          { path: '/', title: 'Home' },
          { path: '/fault/rfo', title: 'RFO Request' },
        ]}
      />
      <Title>RFO Request</Title>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className='row-cols-1 row-cols-md-3 gy-3'>
          <Col>
            <TextInput
              label='Circuit ID'
              required
              useFormRegister={{ ...register('CCTID', { required: true }) }}
              errors={[
                {
                  isShow: errors.CCTID?.type === 'required',
                  message: 'Circuit ID is required',
                },
              ]}
            />
          </Col>
          <Col>
            <TextInput
              label='Fault Reference ID'
              required
              useFormRegister={{
                ...register('faultRefId', { required: true }),
              }}
              errors={[
                {
                  isShow: errors.faultRefId?.type === 'required',
                  message: 'Fault Reference ID is required',
                },
              ]}
            />
          </Col>
          <Col>
            <TextInput
              label='RFO Reference ID'
              required
              useFormRegister={{
                ...register('rfoRefId', { required: true }),
              }}
              errors={[
                {
                  isShow: errors.rfoRefId?.type === 'required',
                  message: 'RFO Reference ID is required',
                },
              ]}
            />
          </Col>
        </Row>
        <Row className='mt-5 justify-content-center'>
          <Col className='col-md-3'>
            <Button type='submit' className='w-100' variant='success'>
              Submit
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default RfoRequest;
